import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Overline } from "./Reveal";
import { TESTIMONIALS } from "../../lib/site";

export default function Testimonials() {
  const [i, setI] = useState(0);
  const go = (d) => setI((prev) => (prev + d + TESTIMONIALS.length) % TESTIMONIALS.length);
  const t = TESTIMONIALS[i];

  return (
    <section id="reviews" className="relative bg-ocean-teal py-14 md:py-20">
      <div className="max-w-[1100px] mx-auto px-6 md:px-10 text-center">
        <Overline>Kind Words</Overline>
        <div className="mt-10 min-h-[280px] md:min-h-[240px] flex items-center justify-center">
          <AnimatePresence mode="wait">
            <motion.blockquote
              key={i}
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -24 }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
              data-testid="testimonial-quote"
            >
              <p className="font-serif font-light italic text-warm-white text-2xl sm:text-3xl md:text-4xl leading-[1.4]">
                “{t.quote}”
              </p>
              <footer className="mt-8">
                <span className="block font-sans font-medium text-antique-gold tracking-wide">{t.name}</span>
                <span className="block font-sans font-light text-sm text-warm-white/70 mt-1">{t.role}</span>
              </footer>
            </motion.blockquote>
          </AnimatePresence>
        </div>

        <div className="mt-10 flex items-center justify-center gap-6">
          <button onClick={() => go(-1)} data-testid="testimonial-prev" aria-label="Previous"
            className="h-11 w-11 rounded-full border border-warm-white/40 flex items-center justify-center text-warm-white hover:bg-warm-white hover:text-ocean-teal transition-colors">
            <ChevronLeft size={18} />
          </button>
          <div className="flex gap-2">
            {TESTIMONIALS.map((_, idx) => (
              <button key={idx} onClick={() => setI(idx)} aria-label={`Review ${idx + 1}`}
                className={`h-1.5 rounded-full transition-all ${idx === i ? "w-8 bg-antique-gold" : "w-1.5 bg-warm-white/30"}`} />
            ))}
          </div>
          <button onClick={() => go(1)} data-testid="testimonial-next" aria-label="Next"
            className="h-11 w-11 rounded-full border border-warm-white/40 flex items-center justify-center text-warm-white hover:bg-warm-white hover:text-ocean-teal transition-colors">
            <ChevronRight size={18} />
          </button>
        </div>
      </div>
    </section>
  );
}
